/**
 * API admin (despacho) del Portal de Clientes — Materialidad.
 * Usa el cliente axios autenticado del workspace.
 */
import api from "@/lib/api";

export async function fetchPortalDocumentTypes() {
  const { data } = await api.get("/tramites/materialidad/portal/document-types");
  return data;
}

export async function fetchPortalUsers() {
  const { data } = await api.get("/tramites/materialidad/portal/users");
  return data;
}

export async function createPortalUser(payload) {
  const { data } = await api.post("/tramites/materialidad/portal/users", payload);
  return data;
}

export async function resetPortalUserPassword(portalUserId) {
  const { data } = await api.post(
    `/tramites/materialidad/portal/users/${encodeURIComponent(portalUserId)}/reset-password`,
  );
  return data;
}

export async function setPortalUserStatus(portalUserId, status) {
  const { data } = await api.patch(
    `/tramites/materialidad/portal/users/${encodeURIComponent(portalUserId)}/status`,
    { status },
  );
  return data;
}

export async function revokePortalAccess(portalUserId, clientId) {
  const { data } = await api.delete(
    `/tramites/materialidad/portal/users/${encodeURIComponent(portalUserId)}/access/${encodeURIComponent(clientId)}`,
  );
  return data;
}

export async function createPortalDocRequest(payload) {
  const { data } = await api.post("/tramites/materialidad/portal/requests", payload);
  return data;
}

export async function fetchPortalDocRequests(clientId) {
  const params = clientId ? { client_id: clientId } : {};
  const { data } = await api.get("/tramites/materialidad/portal/requests", { params });
  return data;
}

export async function fetchPortalDocRequestDetail(requestId) {
  const { data } = await api.get(
    `/tramites/materialidad/portal/requests/${encodeURIComponent(requestId)}`,
  );
  return data;
}

export async function reviewPortalRequestItem(itemId, payload) {
  const { data } = await api.post(
    `/tramites/materialidad/portal/items/${encodeURIComponent(itemId)}/review`,
    payload,
  );
  return data;
}
